'use client';

import { IsoDateField } from '@/components/Form/Fields/DateField/IsoDateField';
import { DISPLAY_DATE_PLACEHOLDER } from '@/components/Form/Fields/DateField/dateFieldIso';
import type { IDefaultFormBuilderProps } from '@/components/Form/Fields/types';
import Label from '@/components/Label/Label';
import InfoIconModal from '@/components/infoIcon/InfoIconModal';
import { RichText } from '@/components/richText/RichText';
import { hasContent } from '@/helper/RichText';
import type { FormDateStoryblok } from '@/types/component-types-sb';
import { type FieldProps } from 'formik';
import { type FC } from 'react';

export {
  DISPLAY_DATE_PLACEHOLDER,
  displayToIso,
  isoToDisplay,
  isPlausibleFormCalendarIso,
  toHtmlDateFieldValue,
} from '@/components/Form/Fields/DateField/dateFieldIso';
export type { IsoDateFieldProps } from '@/components/Form/Fields/DateField/IsoDateField';
export {
  CalendarIsoDateField,
  IsoDateField,
  IsoDateFieldWithoutCalendarButton,
  MaskedIsoDateField,
  NativeIsoDateField,
} from '@/components/Form/Fields/DateField/IsoDateField';

interface IInputField extends FormDateStoryblok, FieldProps, IDefaultFormBuilderProps {}

const DateField: FC<IInputField> = ({
  field,
  id,
  label,
  placeholder,
  infoText,
  errorMessage,
  isInvalid,
  required,
  disabled,
  readOnly,
}) => {
  return (
    <IsoDateField
      {...field}
      disabled={disabled}
      error={isInvalid}
      fullWidth
      helperText={isInvalid && errorMessage}
      id={id}
      label={label && <Label text={label} />}
      placeholder={placeholder ?? DISPLAY_DATE_PLACEHOLDER}
      required={required}
      value={field.value ?? ''}
      InputProps={{
        readOnly,
        endAdornment: hasContent(infoText) ? (
          <InfoIconModal trackingLabel={label ?? field.name}>
            <RichText text={infoText} />
          </InfoIconModal>
        ) : undefined,
      }}
      inputProps={{
        'data-testid': 'form-builder-date-input',
        tabIndex: readOnly ? -1 : 0,
      }}
    />
  );
};

export default DateField;
